import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import ToolTip from '../Shared/Tooltip/Tooltip';
import { AppContext } from '../../Context/AppContext';
import { MY_LOADS_PAGINATION } from '../../Constants/Constants';
import './MyLoadsTabsComponent.scss';

export type TMyLoadsTabsComponent = {
  tabs: any[];
  handleTabChange: (slug: string) => void;
};

const MyLoadsTabsComponent = ({ tabs, handleTabChange }: TMyLoadsTabsComponent) => {
  const { isMobile } = useContext(AppContext);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  return (
    <div
      className={`MyLoadsTabs_Container ${isMobile ? 'mobile grid-container' : 'web'}`}
      tabs-testid="MyLoadsTabs_Container"
    >
      {tabs?.map((item: any, index: number) => {
        return (
          <div
            key={item?.slug}
            className={`MyLoadsTabs_Tab ${item?.slug} ${item?.selected ? 'selected' : ''} ${item?.count === 0 ? 'Deactive_Icons' : ''}  ${isMobile ? '' : 'web'}
              } ${!!item?.count ? 'noload' : ''}`}
            onClick={() => {
              if (item?.count === 0) {
                setSelectedIndex(index);
                isMobile && toast('No Routes currently in this status.');
              } else {
                handleTabChange(item?.slug);
              }
            }}
            data-testid={item?.slug}
          >
            <div className="Grid_Item">
              {isMobile && <div className="Loads_Count">{item?.count > MY_LOADS_PAGINATION.PAGE_SIZE ? `${MY_LOADS_PAGINATION.PAGE_SIZE}+` : item?.count}</div>}
              <img src={`/oo/assets/icon/${item?.icon}`} alt="count" />
              <div className="Tab_Title">{isMobile ? item?.MobTitle : item?.WebTitle}</div>
            </div>
            {!isMobile && <div className="Loads_Count">{item?.count > MY_LOADS_PAGINATION.PAGE_SIZE ? `${MY_LOADS_PAGINATION.PAGE_SIZE}+` : item?.count}</div>}
            <div className="Tooltip_Container">
              <ToolTip
                message={'No Routes currently in this status.'}
                isActive={!isMobile && selectedIndex === index}
                clearIndex={() => setSelectedIndex(null)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MyLoadsTabsComponent;
